module.exports = __webpack_public_path__ + "img/Zugtrupp_Wasserrettung.610a93f3.svg";